import { useTranslation } from "react-i18next";
import PageLayout from "@/components/feature/PageLayout";
import LegalSections from "@/pages/legal/LegalSections";
import { useLang } from "@/lib/useLang";
import { TERMS } from "@/data/pages";

export default function TermsPage() {
  const { t } = useTranslation();
  const lang = useLang();
  const terms = TERMS[lang];

  return (
    <PageLayout eyebrow="TERMS OF USE" title={t("footer.terms")} desc={`${t("legal.effective")}: ${terms.effective}`}>
      <div className="max-w-3xl">
        <LegalSections sections={terms.sections} />
      </div>
    </PageLayout>
  );
}
